import { createSlice } from "@reduxjs/toolkit";
import {
  getCandidateCompetencyScores,
  computeCandidateCompetencyScores,
  candidateKey,
} from "../actions/candidate-competency-score-actions";

const initialState = {
  byCandidate: {},
  loadingByCandidate: {},
  error: null,
};

const candidateCompetencyScoreSlice = createSlice({
  name: "candidateCompetencyScore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCandidateCompetencyScores.pending, (state, action) => {
        const k = candidateKey(action.meta.arg.interviewId, action.meta.arg.userId);
        state.loadingByCandidate[k] = true;
      })
      .addCase(getCandidateCompetencyScores.fulfilled, (state, action) => {
        const { key, items } = action.payload;
        state.loadingByCandidate[key] = false;
        state.byCandidate[key] = items;
      })
      .addCase(getCandidateCompetencyScores.rejected, (state, action) => {
        const k = candidateKey(action.meta.arg.interviewId, action.meta.arg.userId);
        state.loadingByCandidate[k] = false;
        state.error = action.payload;
      })
      .addCase(computeCandidateCompetencyScores.fulfilled, (state, action) => {
        const { key, items } = action.payload;
        state.byCandidate[key] = items;
      });
  },
});

const candidateCompetencyScoreSliceReducer = candidateCompetencyScoreSlice.reducer;
export default candidateCompetencyScoreSliceReducer;
